import React, { Component } from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShare, faCopy } from '@fortawesome/free-solid-svg-icons'


class TempURL extends Component {
  constructor(props) {
    super(props);

    this.state = {
      expiration: null,
    }
    this.logUrlRef = React.createRef();
  }

  createURL() {
    if (!this.props.onCreateURL) {
      return;
    }
    this.props.onCreateURL((path, expiration) => {
      this.setState({
        url: this.props.baseURL + path,
        expiration,
      })
    })
  }

  copyURL() {
    const copyText = this.logUrlRef.current
    copyText.select()
    copyText.setSelectionRange(0, 99999) /*For mobile devices*/
    document.execCommand("copy")
  }

  render() {
    return (this.state.expiration === null || Date.now() > this.state.expiration ?
      <Button
        data-test-create-log-url
        onClick={ev => this.createURL()}
        variant='light'>
        <FontAwesomeIcon icon={faShare} />
        {this.props.name}を生成{this.props.notice}
      </Button> :
      <div>
        <Form.Control
          data-test-log-url-input
          readonly
          ref={this.logUrlRef}
          value={this.state.url} />
        <Button
          data-test-create-log-url
          onClick={ev => this.copyURL()}
          variant='light'>
          <FontAwesomeIcon icon={faCopy} />
          {this.props.name}をコピー{this.props.notice}
        </Button>
      </div>);
  }
}

export default TempURL;
